(ns teamoesterreich.user-mode.onboarding.required-fields
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.cake :refer [cake]]
    [reagent-material-ui.icons.edit :refer [edit]]
    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.modal.address-modal :as address-modal]
    [teamoesterreich.util.helper :as h]
    ["react" :as react]))

(defn parse-date-to-millis [dStr]
  (try
    (let [d (js/Date.parse (str dStr " 10:00:00"))]
      (when-not (js/isNaN d)
        d))
    (catch js/Error e
      nil)))

(defn has-address? [user]
  (and (some? (:main_address user))
       (not-empty (get-in user [:main_address :zip]))
       (not-empty (get-in user [:main_address :city]))
       (not-empty (get-in user [:main_address :street]))))

(defn inner []
  (let [!actual-user (r/cursor store/app-state [:actual-user])
        !edit-address (r/atom false)
        [birthday set-birthday] (react/useState (:birthday @!actual-user))]
    (react/useEffect (fn []
                       (when (and (some? birthday) (has-address? @!actual-user))
                         (a/set-page :landing)))
                     #js[])
    (a/set-bottom-action-fn #(a/go-home))

    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "center"
      :alignItems "flex-start"
      :spacing    4

      :style      {:backgroundColor (txt/txt :style :bg-color)
                   :padding         "2rem"}
      }
     [mui/grid
      {:container false :item true
       :md        6                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }
      [mui/paper {:class ""
                  :style {:textAlign "left" :padding "25px"}}

       [mui/box {:sx {:display       "flex"
                      :flexDirection "column"
                      :gap           "1rem"}}
        [mui/typography {:variant "h6"}
         "Hallo " (get-in @!actual-user [:name :first])]
        [mui/typography {:variant "body1"}
         (txt/txt :requiredFields "Vielen Dank, dass du bei Team mithelfen möchtest!")
         [:br]
         (txt/txt :requiredFields "Um dich für Team Einsätze alarmieren zu können benötigen wir noch Daten von dir.")]

        (when (or (nil? (:birthday @!actual-user)))
          [:<>
           (when (nil? (:birthday @!actual-user))
             [:<>
              [mui/typography {:variant "body1" :sx {:margin-top "2rem"}}
               "Da man für die meisten Einsätze volljährig sein muss, benötigen wir dein Geburtsdatum."]
              [mui/text-field {
                               :fullWidth       true
                               :InputLabelProps {:disableAnimation true :shrink true}
                               :type            "date"
                               :size            "small"
                               :format          "dd.MM.yyyy"
                               :label           (str "Geburtsdatum ⁽*⁾ ")
                               ;:onChange (change-fn [:birthplace])
                               :onChange        (fn [e] (set-birthday (h/event-value e)))
                               :defaultValue    birthday
                               :InputProps      {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [cake {:style {:font-size "14px"}}]])}
                               }]
              ])
           ])

        (when-not (has-address? @!actual-user)
          [:<>
           [mui/typography {:variant "body1" :sx {:margin-top "2rem"}}
            "Damit wir dich regional verwalten und zu Einsätzen in deiner Gegend alarmieren können, benötigen wir deine Adresse."]

           [mui/button {:style     {:justifyContent "left"}
                        :variant   "contained"
                        :startIcon (r/as-element [edit])
                        :onClick   #(reset! !edit-address true)
                        }
            "Adresse bearbeiten"]
           ])

        (if (and (or (some? (:birthday @!actual-user))
                     (and (some? birthday) (some? (parse-date-to-millis birthday))))
                 (has-address? @!actual-user))
          [mui/button {:component "a" :href "/"
                       :variant   "contained"
                       :color     "primary"
                       :onClick   (fn [e]
                                    (.preventDefault e)
                                    (a/set-user-details {:birthday (js/firebase.firestore.Timestamp.fromMillis (parse-date-to-millis birthday))})
                                    (a/set-page :landing))}
           "Weiter"]

          [mui/button {:component "a" :href "/"
                       :variant   "outlined"
                       :onClick   (fn [e]
                                    (.preventDefault e)
                                    (a/set-page :landing))}
           "Später ausfüllen"])

        ]

       [address-modal/address-modal !edit-address]

       ]
      [:br] [:br]
      ]
     ]
    ))

(defn get-it []
  [:f> inner])









